import React from 'react'

const PlusIcon = ({
  width = 12,
  height = 12,
  color = '#bf9000',
  disabled = false,
  className = '',
}) => {
  const fillColor = disabled ? '#ccc' : color

  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width={width}
      height={height}
      viewBox='0 0 448 512'
      fill='none'
      className={className}>
      <path
        fill={fillColor}
        d='M256 80c0-17.7-14.3-32-32-32s-32 14.3-32 32V192H80c-17.7 0-32 14.3-32 32s14.3 32 32 32H192V368c0 17.7 14.3 32 32 32s32-14.3 32-32V256H368c17.7 0 32-14.3 32-32s-14.3-32-32-32H256V80z'
      />
    </svg>
  )
}

export default PlusIcon
